// scroll-navigation.jsx
import { useEffect, useCallback, useRef, useState } from "react"

const SCROLL_THRESHOLD = 30
const DEBOUNCE_DELAY = 1000
const MOBILE_BREAKPOINT = 1279

export const useScrollNavigation = ({ onNext, onPrev }) => {
  const lastScrollTime = useRef(0)
  const [isMobile, setIsMobile] = useState(false)

  // Handle screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT)
    }

    handleResize() // Initial check
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleScroll = useCallback(
    (e) => {
      // Don't handle scroll on mobile
      if (isMobile) return

      e.preventDefault()

      const now = Date.now()
      if (now - lastScrollTime.current < DEBOUNCE_DELAY) {
        return
      }

      const delta = e.deltaY
      if (Math.abs(delta) < SCROLL_THRESHOLD) {
        return
      }

      lastScrollTime.current = now

      if (delta > 0) {
        onNext?.()
      } else {
        onPrev?.()
      }
    },
    [onNext, onPrev, isMobile]
  )

  useEffect(() => {
    // Only add scroll listeners if not mobile
    if (isMobile) return

    const preventScroll = (e) => {
      e.preventDefault()
    }

    window.addEventListener("wheel", handleScroll, { passive: false })
    document.addEventListener("touchmove", preventScroll, { passive: false })

    return () => {
      window.removeEventListener("wheel", handleScroll)
      document.removeEventListener("touchmove", preventScroll)
    }
  }, [handleScroll, isMobile])

  // Return isMobile state in case it's needed by the parent
  return { isMobile }
}
